export enum ErrorCode {
    None = 0,
    UnsupportedFileType = 1,
    SqlTimeOutException = 2,
    JobDoesNotExistInQueue = 3,
    JobLockedByAnotherSession = 4,
    InvalidConfiguration = 5,
    DocumentPageShuffleSucceededReIndexFailed = 6,
    EncryptionError = 7
}
